<template>
  <div>
    <div class="container">
      <!--      <div class="row g-5 pb-4 ">-->
      <!--        <h1>Why I Program!</h1>-->
      <!--        <div class="col-4 border-bottom" v-for="proj of motive" :key="proj.link">-->
      <!--          <h2 v-html="proj.title"></h2>-->
      <!--          <div v-html="proj.body"/>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="row mb-3 mt-3 pt-4 pb-4 border-top border-bottom ">-->
      <!--        <div class="col text-center text-secondary ">-->
      <!--          <i class="fa fa-arrow-circle-down fa-3x"></i>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row g-5">
        <h1>Major Projects</h1>
        <div class="col-6 border-bottom" v-for="proj of major" :key="proj.link">
          <h2>
            <a
              class="text-decoration-none fw-bold"
              :href="proj.link"
              v-html="proj.title"
            />
          </h2>
          <div v-html="proj.body" />
        </div>
      </div>

      <Separator />

      <div class="row g-5">
        <h1>Other Projects</h1>
        <div
          class="col-12 border-bottom"
          v-for="proj of minor"
          :key="proj.link"
        >
          <h4>
            <a
              class="text-decoration-none fw-bold"
              :href="proj.link"
              v-html="proj.body"
            />
          </h4>
        </div>
      </div>

      <Separator />
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store/projects";
import Separator from "@/components/Common/Separator";

export default defineComponent({
  name: "ProjectsContent",
  components: { Separator },
  computed: {
    // motive() { return store.state.motive },
    major() {
      return store.state.major;
    },
    minor() {
      return store.state.minor;
    },
  },
});
</script>

<style scoped></style>
